import React, { useMemo } from 'react';

import type {
  DynamicBannerTemplate,
  EventDynamicBanner,
  ImageFetchProps
} from '../../../model/types';

import BetBuilderDynamicBanner from './templates/BetBuilder';
import StandardEventDynamicBanner from './templates/Standard';

type EventDynamicBannerTemplate = Extract<DynamicBannerTemplate, 'BET_BUILDER' | 'STANDARD'>;

const bannerComponents: Record<
  EventDynamicBannerTemplate,
  React.FC<EventDynamicBanner & ImageFetchProps>
> = {
  BET_BUILDER: BetBuilderDynamicBanner,
  STANDARD: StandardEventDynamicBanner
};

const EventBanner: React.FC<EventDynamicBanner & ImageFetchProps> = (props) => {
  const { template } = props;
  const BannerContentComponent = useMemo(
    () =>
      template !== 'ODDS_BOOST' && template !== 'REQUEST_A_BET' ? bannerComponents[template] : null,
    [template]
  );

  if (!BannerContentComponent) return null;

  return <BannerContentComponent {...props} />;
};

export default EventBanner;
